export const version = '2.21.54';
//# sourceMappingURL=version.js.map